import axios from "axios";

const BASE = "/api/progress";

export function getByTopic(topicId) {
  return axios.get(`${BASE}/by-topic/${topicId}`);
}

export function add({ topicId, item }) {
  return axios.post(BASE, { topicId, item });
}

export function removeItem({ topicId, item }) {
  return axios.delete(`${BASE}/items`, { data: { topicId, item } });
}
